import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-row items-center text-sm font-medium" }
const _hoisted_3 = { class: "text-white mr-2" }
const _hoisted_4 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_5 = {
  key: 1,
  class: "flex flex-row flex-wrap space-x-2 max-w-full items-center -mb-2 ml-2"
}
const _hoisted_6 = {
  key: 0,
  class: "text-white text-sm font-medium ml-4 mb-2"
}
const _hoisted_7 = { class: "rounded-full flex items-center bg-gray-800 text-white p-2 hover:bg-gray-600 focus:bg-gray-600 focus:outline-none" }

import { computed, onMounted, PropType, ref } from 'vue';
import { ISuggestion } from '@/lib';
import { FullIndicator, Indicator } from '@/models';
import { BaseIcon } from '@/lib/components/Icon';
import { BaseChip } from '@/lib/components/Chip';
import { SearchSelect } from '@/lib/components/Search';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScanSigns',
  props: {
  modelValue: {
    type: Array as PropType<FullIndicator[]>,
    default: () => []
  },
  list: {
    type: Array as PropType<Indicator[]>,
    default: () => []
  }
},
  emits: ["search", "update:modelValue", "add", "loadNext", "remove"],
  setup(__props, { emit }: { emit: ({
  (e: 'search', value: string): void;
  (e: 'update:modelValue', value: FullIndicator[]): void;
  (e: 'add', value: ISuggestion): void;
  (e: 'loadNext'): void;
  (e: 'remove', id: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;




const add = ref(false);

const indicators = computed<ISuggestion[]>(() => props.modelValue.map((sign) => ({
  id: sign.indicator.id,
  label: sign.indicator.name
})));

onMounted(() => {
  window.addEventListener('click', () => (add.value = false));
});
const removeSign = (id: string) => {
  const value = [...props.modelValue].filter((chip) => chip.id !== id);
  emit('update:modelValue', value);
  emit('remove', id);
};
const removeSignFromSearchSelect = (id: string) => {
  const sign = props.modelValue.find((sign) => sign.indicator.id === id);
  if (sign) {
    emit('remove', sign.id);
    const value = [...props.modelValue].filter((s) => s.id !== sign.id);
    emit('update:modelValue', value);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex flex-row pl-4 pr-2 py-1 items-center justify-between rounded mb-2 cursor-pointer",
      style: {"background":"rgba(28, 28, 28, 0.9)"},
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (add.value = !add.value), ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('custom.uhb.scans.sign.signs')), 1),
        (!__props.modelValue.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('custom.uhb.scans.sign.no-signs')), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue, (sign, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: sign.indicator.id
                }, [
                  (add.value || index < 2)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "mb-2",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createVNode(_unref(BaseChip), {
                          removable: "",
                          dark: "",
                          onRemoved: ($event: any) => (removeSign(sign.id))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(sign.indicator.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["onRemoved"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              (!add.value && __props.modelValue.length > 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('custom.uhb.scans.sign.more', { value: __props.modelValue.length - 2 })), 1))
                : _createCommentVNode("", true)
            ]))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(BaseIcon), {
          name: add.value ? 'chevron-up' : 'add'
        }, null, 8, ["name"])
      ])
    ]),
    (add.value)
      ? (_openBlock(), _createBlock(_unref(SearchSelect), {
          key: 0,
          "model-value": _unref(indicators),
          list: __props.list,
          placeholder: "Search by name",
          dark: "",
          filter: false,
          onSearch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('search', $event))),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
          onAdd: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('add', $event))),
          onRemove: _cache[5] || (_cache[5] = ($event: any) => (removeSignFromSearchSelect($event))),
          onScrolled: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('loadNext')))
        }, null, 8, ["model-value", "list"]))
      : _createCommentVNode("", true)
  ]))
}
}

})